module.exports = __webpack_public_path__ + "img/iphone8.fbe7eb4b.png";